
interface AuthState {
  loading: boolean;
  loggedIn: boolean;
  error: null;
  user: any;
}

interface Action {
  type: string;
  payload?: any;
}

const initialState = {
  loading: false,
  loggedIn: false,
  error: null,
  user: null,
};

const authReducer = (state: AuthState = initialState, action: Action) => {
  switch (action.type) {
    case 'LOGIN_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'LOGIN_SUCCESS':
      localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        loading: false,
        loggedIn: true,
        user: action.payload,
      };
    case 'LOGIN_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'LOGOUT':
      localStorage.removeItem('token');
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default authReducer;
